import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
// import chroma from 'chroma-js';
import { withAsyncPaginate } from "react-select-async-paginate";
const AsyncPaginate = withAsyncPaginate(Select);

const SelectAsyncPaginateStores = (props) => {
    const [reloadKey, setReloadKey] = useState(0);

    const loadOptions = async (
        searchQuery,
        loadedOptions,
        { page }
    ) => {
        const token = JSON.parse(localStorage.getItem("user")).token;
        const response = await fetch(
            `${props.apiLink}?search=${searchQuery}&pageNumber=${page}&pageSize=10`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        const responseJSON = await response.json();
        let optionsList = responseJSON?.pharmacies?.map((item) => ({
            label: item.name, 
            value: item?.id,
        }));

        if (props.filterOptions) {
            optionsList = optionsList.filter(props.filterOptions);
        }

        return {
            options: optionsList,
            hasMore: responseJSON?.pagination?.hasNextPage,
            additional: {
                page: page + 1,
            },
        };
    };

    const onChange = (option) => {
        if (typeof props.onChange === "function") {
            props.onChange(option);
        }
    };

    useEffect(() => {
        if (props.reload) {
            setReloadKey(prevKey => prevKey + 1);
        }
    }, [props.reload]);
    
    
    const dot = (color = props.color) => ({
        alignItems: 'center',
        display: 'flex',
      
        ':before': {
          backgroundColor: color,
          borderRadius: 10,
          content: '" "',
          display: 'block',
          marginRight: 8,
          height: 10,
          width: 10,
        },
      });
      
      const colourStyles = {
        input: (styles) => ({ ...styles, ...dot() }),
        placeholder: (styles) => ({ ...styles, ...dot(props.color) }),
        singleValue: (styles, { data }) => ({ ...styles, ...dot(props.color) }),
      };
    return (
        <AsyncPaginate
            key={reloadKey}
            loadOptions={loadOptions}
            value={props?.value}
            onChange={onChange}
            placeholder={props?.placeholder}
            additional={{
                page: 1,
            }}
            isDisabled={props?.isDisabled}
            className={props?.width}
            isClearable={props?.isClearable}
            isMulti={props?.isMulti}
            styles={props.color ? colourStyles : {}}
        />
    );
};

SelectAsyncPaginateStores.propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
    apiLink: PropTypes.string.isRequired,
    filterOptions: PropTypes.func,
    placeholder: PropTypes.string,
    isDisabled: PropTypes.bool,
    isClearable: PropTypes.bool,
    isMulti: PropTypes.bool,
    width: PropTypes.string,
    reload: PropTypes.bool,
};

export default SelectAsyncPaginateStores;
